"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeRegistry = exports.FormatRegistry = void 0;
exports.FormatRegistry = require("./format");
exports.TypeRegistry = require("./type");
